<script setup lang="tsx">
import { ref, onMounted, inject } from "vue";
import { Context } from "@zyzgroup/core-web";
import { useRouter } from "../../hooks";
import LayoutPage from "../layout/LayoutPage.vue";
import Footer from "./Footer.vue";
import PlateDisplay from "../plate/PlateDisplay.vue";
import ImageView from "../image/ImageView.vue";
import ViewDocument from "../form/ViewDocument.vue";
import PopTel from "../pop/PopTel.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {
    LayoutPage,
    Footer,
    PlateDisplay,
    ViewDocument,
    PopTel,
    ImageView
  },
  inheritAttrs: true
});

const router = useRouter();

let billsn = ref(0);
let fee = ref(0);

function viewDocument() {
  router.push({
    name: "view-document",
    params: {
      title: "收费标准",
      src: encodeURIComponent(
        "https://erichd2.oss-cn-shanghai.aliyuncs.com/0000/0002/2159"
      )
    }
  });
}

const popTelEl = ref();
function call() {
  popTelEl.value?.open();
}

const imageViewEl = ref();
function viewPhotos() {
  imageViewEl.value?.open();
}

const context = inject<Context>("context");

onMounted(() => {
  context.axios
    .post(`/api/v6/lot/740/getwithorder6`, {
      openid: "quickpassapp"
    })
    .then((result) => {
      // console.log(result);
      // console.log(JSON.stringify(result));
      billsn.value = result.data.bill.sn;
      fee.value = result.data.bill.fee;
    })
    .catch((result) => {
      // console.log(result);
      // console.log(JSON.stringify(result));
    });
});
</script>

<template>
  <LayoutPage class="lot">
    <div class="lot-main-bg"></div>
    <div class="lot-main">
      <div>若临测试泊位机器人停车场</div>
      <div>
        <div></div>
        <div>编号</div>
        <div></div>
      </div>
      <div>
        <span>103</span>
        <span>003</span>
      </div>
      <div>
        <!-- <div>停车场主页</div>
        <div>更换附近车位</div>
        <div @click="viewDocument">收费标准</div> -->
      </div>
      <div class="lot-detail">
        <div>
          <div>待支付</div>
          <div class="red">￥{{ (fee / 100).toFixed(2) }}</div>
        </div>
        <!-- <div>
          <div>已支付</div>
          <div>￥0.01</div>
        </div> -->
        <div>
          <div>订单编号</div>
          <div>33333333333</div>
        </div>
        <div>
          <div>开始时间</div>
          <div>2025-04-08 09:41:25</div>
        </div>
        <div>
          <div>停车时长</div>
          <div>1小时53分钟15秒</div>
        </div>
        <!-- <div>
          <div>优惠券</div>
          <div class="red">1分钟</div>
        </div>
        <div>
          <div>优惠信息</div>
          <div class="red">xxxx</div>
        </div> -->
        <!-- <div>
          <div>包月开始时间</div>
          <div>2025-04-08 09:41:25</div>
        </div>
        <div>
          <div>包月结束时间</div>
          <div>2025-04-08 09:41:25</div>
        </div> -->
        <div class="lot-detail-gap"></div>
        <div>
          <div>车牌号</div>
          <div class="bold">
            <PlateDisplay
              plate="苏U77777"
              plate-type="b"
            ></PlateDisplay>
          </div>
        </div>
        <!-- <div>
          <div>现场照片</div>
          <div @click="viewPhotos">查看</div>
        </div> -->
      </div>
      <div class="lot-actions">
        <div @click="call">联系客服</div>
      </div>
    </div>
    <template #footer><Footer :billsn="billsn"></Footer></template>
    <template #global>
      <PopTel
        tel="15851575410"
        ref="popTelEl"
      ></PopTel>
      <ImageView
        :urls="[
          'https://erichd2.oss-cn-shanghai.aliyuncs.com/0000/0002/2159',
          'https://erichd2.oss-cn-shanghai.aliyuncs.com/0000/0002/2159'
        ]"
        ref="imageViewEl"
      ></ImageView>
    </template>
  </LayoutPage>
</template>

<style scoped>
.lot-main-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 5.2rem;
  border-bottom-left-radius: 2rem 0.5rem;
  border-bottom-right-radius: 2rem 0.5rem;
  background: linear-gradient(180deg, #5a82f0 0%, #66b3ff 100%);
}
.lot-main {
  position: relative;
  z-index: 2;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  line-height: 1;
  color: #ffffff;
  padding: 0 0.3rem;
  margin-bottom: 0.3rem;
  text-align: center;
}
.lot-main > div:nth-child(1) {
  font-size: 0.32rem;
  padding-top: 0.4rem;
  word-break: break-all;
  font-weight: bold;
}
.lot-main > div:nth-child(2) > div:nth-child(1) {
  width: 2.4rem;
  height: 0.04rem;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}
.lot-main > div:nth-child(2) > div:nth-child(3) {
  width: 2.4rem;
  height: 0.04rem;
  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
}
.lot-main > div:nth-child(2) > div:nth-child(2) {
  width: 1rem;
  font-size: 0.28rem;
  line-height: 0.32rem;
}
.lot-main > div:nth-child(2) {
  display: flex;
  align-items: center;
  margin: 0.28rem auto 0;
  width: 4.8rem;
  position: relative;
}
.lot-main > div:nth-child(3) {
  font-family: "D-DINExp-Bold-number";
  margin-top: 0.12rem;
  font-size: 0.8rem;
  letter-spacing: 0.06rem;
}
.lot-main > div:nth-child(3) > span + span {
  margin-left: 0.3rem;
}
.lot-main > div:nth-child(4) {
  display: flex;
  justify-content: space-between;
  font-size: 0.28rem;
  line-height: 0.28rem;
  margin: 0.3rem 0;
}
.lot-main > div:nth-child(4) > div {
  flex: 1 1 auto;
  text-align: center;
}
.lot-main > div:nth-child(4) > div + div {
  border-left: 1px solid rgba(255, 255, 255, 0.4);
}
.lot-detail {
  position: relative;
  background: #ffffff;
  box-shadow: 0 0.04rem 0.1rem rgba(0, 0, 0, 0.1);
  border-radius: 0.08rem;
  padding: 0 0.3rem 0.1rem;
  font-size: 0.28rem;
  color: #666666;
}
.lot-detail > div {
  line-height: 0.4rem;
  margin: 0.2rem auto;
  display: flex;
  justify-content: space-between;
}
.lot-detail > div:nth-child(1) {
  border-bottom: 1px solid var(--yz-xg-border-color);
  line-height: 0.88rem;
  margin: 0 0 0.2rem;
  font-weight: bold;
}
.lot-detail > div:nth-child(1) > div:nth-child(2) {
  font-size: 0.4rem;
}
.lot-detail > div > div:nth-child(1) {
  flex: 0 0 auto;
  padding-right: 0.2rem;
}
.lot-detail > div > div:nth-child(2) {
  color: #333333;
}
.lot-detail-gap {
  border-top: 1px solid var(--yz-xg-border-color);
}
.lot-actions {
  margin: 0.2rem 0;
  background: #ffffff;
  box-shadow: 0px 0.04rem 0.1rem rgba(0, 0, 0, 0.1);
  border-radius: 0.08rem;
  display: flex;
  align-items: center;
  font-size: 0.28rem;
}
.lot-actions > div {
  flex: 1;
  line-height: 0.88rem;
  position: relative;
  cursor: pointer;
  color: var(--yz-xg-primary);
  text-align: center;
  font-weight: 700;
}
</style>
